// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".notice[data-v-2e48d1ce]{background-color:var(--v-grayDarkest-lighten1)}.notice[data-v-2e48d1ce] a{webkit-text-decoration-line:underline!important;color:var(--g-text-primary)!important;text-decoration-line:underline!important}.notice[data-v-2e48d1ce] a:active,.notice[data-v-2e48d1ce] a:focus,.notice[data-v-2e48d1ce] a:hover{webkit-text-decoration-line:none!important;text-decoration-line:none!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
